<!-- eslint-disable no-undef -->
<template>
  <OnboardingLoading
      v-if="payLoading"
      :style="{
        position: 'absolute',
        inset: 0,
        right: isMobile() ? '36px' : 0,
      }"
      loadingText="Autorizando pagamento..."
      onSucessGoTo="onboarding-complete"
      :hideErrorLoading="true"
    />
  <div v-else>
    <div
      :class="isOnlyCredit ? 'hidden-selector' : 'payment-method-wrapper'"
    >
      <div class="options"
      :class="option.selected ? 'selected' : ''" v-for="(option, indexOption) in currentOptions"
        :key="option + indexOption" @click="() => selectMethod(option)" :id="option.type">
        <div class="label-wrapper">
          <div style="display: flex; align-items: center; height: 24px; width: 24px">
            <asset-v3 class="paymentIcon" :name="`${option.type}.svg`" dir="icons" />
          </div>
          {{ option.label }}
        </div>
        <input type="radio" name="payment-selector" class="payment-selector-radio-input" />
      </div>
    </div>
    <div class="ticket" v-if="currentSelected.type === 'billet-method'">
      <h1 v-if="isMobile()" class="instruction-wrapper-title">Pagar com Boleto</h1>
      <div class="title-barcode">
        Escaneie ou copie e cole o código de barras para pagamento online.
      </div>
      <div class="barcode" :class="{ mobile: isMobile() }">
        <VueBarcode v-if="!isMobile()" class="barcode-svg" tag="svg" format="ITF" lineColor="#000"
          :value="order.billet.barCodeNumber"
          :displayValue="false" :fontSize="40" :marginLeft="0" :width="1" />
        <input id="inputBarcode" style="display: none" v-model="order.billet.payNumber" />
        <input type="hidden" id="inputBarcode" :value="order.billet.payNumber" />
        <div class="barcode-number">
          {{ order.billet.payNumber | barcodeFilter }}
        </div>
      </div>
      <div class="barcode-options">
        <v-popover :style="isMobile() ? 'width: 100%;' : ''" :offset="16"
        placement="bottom" :show="!tooltipDisabled"
          :autoHide="true">
          <Button text="Copiar código" class="grey-hover ticket-button"
            :action="() => copyBarcode(order.billet.payNumber)"
            :icon="isSmall ? 'copy-white' : 'copy'" />
          <template slot="popover">
            <div class="tooltip-arrow"></div>
            <div class="tooltip-text">Código copiado</div>
          </template>
        </v-popover>
        <Button text="Baixar Boleto" :icon="isMobile() ? '' : 'download'"
        class="grey-hover ticket-button"
          :action="() => openBillet()" />
      </div>
      <div class="disclaimer">
        <p>
          Você será avisado assim que o pagamento for confirmado.
          A confirmação pode demorar até 2 dias úteis após a realização do pagamento.
        </p>
        <p>
          Caso o pagamento não seja confirmado em até 3 dias úteis após
          o vencimento, o pedido será cancelado.
        </p>
      </div>
    </div>
    <div class="pix" v-else-if="currentSelected.type === 'pix-method'">
      <div class="pix-content">
        <div class="qr-code">
          <div class="qr-code-box" @click="() => copyPixCode(order.pix.pixCode)">
            <QRCode :value="order.pix.pixCode" />
          </div>
          <div class="scan">Escaneie o código acima ou</div>
          <v-popover :offset="16" placement="bottom" :show="!tooltipDisabled" :autoHide="true">
            <div class="button-copy" @click="() => copyPixCode(order.pix.pixCode)">
              <asset-v3 dir="icons" name="copy.svg" />
              Copiar código
            </div>

            <template slot="popover">
              <div class="tooltip-arrow"></div>
              <div class="tooltip-text">Código copiado</div>
            </template>
          </v-popover>
        </div>
        <h1 v-if="isMobile()" class="instruction-wrapper-title">Pagar com Pix</h1>
        <div class="instructions" :class="{ mobile: isMobile() }">
          <div class="instruction-wrapper">
            <span class="instruction-wrapper-number">1</span>
            Abra seu aplicativo financeiro de preferência.
          </div>
          <div class="instruction-wrapper">
            <span class="instruction-wrapper-number">2</span>
            <span v-if="isMobile()"> Cole o código copiado para realizar o pagamento. </span>
            <span v-else>
              Escaneie o código QR ao lado ou copie e cole o código para realizar o pagamento.
            </span>
          </div>
          <div class="instruction-wrapper">
            <span class="instruction-wrapper-number">3</span>
            Revise os dados informados e aguarde a confirmação. Pronto!
          </div>
        </div>
        <div class="copy-buttom-sm" v-if="isSmall">
          <v-popover :offset="16" placement="bottom" :show="!tooltipDisabled" :autoHide="true">
            <Button text="Copiar código Pix" class="grey-hover ticket-button"
              :action="() => copyPixCode(order.pix.pixCode)" icon="copy-white" />
            <template slot="popover">
              <div class="tooltip-arrow"></div>
              <div class="tooltip-text">Código copiado</div>
            </template>
          </v-popover>
        </div>
      </div>
      <div class="disclaimer-pix">
        <p>
          Você será avisado assim que o pagamento for confirmado. A confirmação pode demorar até 1
          dias útil após a realização do pagamento.
        </p>
        <p>
          Caso o pagamento não seja confirmado em até 1 dias útil após o vencimento, o boleto será
          cancelado juntamente com o pedido.
        </p>
      </div>
    </div>
    <div class="credit" v-else-if="currentSelected.type === 'credit-card'">
      <h2 v-if="isMobile()" class="credit-title">Pagar com cartão de crédito</h2>
      <form class="credit-form" @submit.prevent="createCreditCardPaymentToken">
        <div style="display: flex; flex-direction: row; position: relative; width: 100%;">
          <Input
            label="Número do cartão"
            v-model="creditCard.number"
            hasIcon
            inputmode="numeric"
            @blur="cleanErrors('number')"
            @input="getCreditCardLogo"
            class="credit-form-input"
            :errorMessage="validate.number"
            v-mask="'#### #### #### ####'"
          />
          <img
            :src="cardLogo"
            style="position: absolute; left: 12px; width: 24px; height: 24px;"
            :style="{ top: isMobile() ? '36px' : '32px' }"
          />
        </div>
        <Input
          label="Nome impresso no cartão"
          v-model="creditCard.full_name"
          @blur="cleanErrors('name')"
          class="credit-form-input name"
          :errorMessage="validate.name"
        />
        <div style="display: flex; gap: 20px">
          <Input
            label="Validade"
            v-mask="'##/####'"
            style="margin-bottom: 0;"
            inputmode="numeric"
            placeholder="MM/YYYY"
            @blur="cleanErrors('expiration')"
            v-model="creditCard.expiration"
            :errorMessage="validate.expiration"
            />
          <div style="display: flex; flex-direction: row; position: relative; width: 100%;">
            <Input
              label="Cód. segurança"
              @blur="cleanErrors('verification_value')"
              style="margin-bottom: 0;"
              inputmode="numeric"
              labelWrap
              hasIconRight
              v-model="creditCard.verification_value"
              :errorMessage="validate.verification_value"
            />

            <v-popover
              style="position: absolute;
              right: 10px;"
              :style="{ top: isMobile() ? '36px' : '32px' }"
              :offset="16"
              placement="top"
              :show="!tooltipDisabled"
              :autoHide="true"
            >
              <button
                type="button"
                class="tooltipButton"
                @click="showCVVTooltip()"
              >
                <QuestionMarkCircleIcon />
              </button>
            <template slot="popover">
              <div class="tooltip-arrow-cvv"></div>
              <div class="tooltip-text-cvv">
                O código de segurança (CVV) é composto por 3 ou 4 números e fica geralmente na
                parte de trás do cartão.
              </div>
            </template>
          </v-popover>
          </div>
        </div>
        <!-- <Toggle
          v-if="isMobile()"
          v-model="saveCardToken"
          label="Salvar dados do cartão para pagamentos futuros"
        />
        <CheckBox
          v-else
          style="font-family: Usual;
          font-size: 16px;
          font-style: normal;
          font-weight: 400;
          line-height: 24px;"
          v-model="saveCardToken"
          label="Salvar dados do cartão para pagamentos futuros"
        /> -->
        <UIButton type="submit" :disabled="payLoading" class="primary pay-button">
          {{ payButtonText }}
        </UIButton>
      </form>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { mask } from 'vue-the-mask';
import VTooltip from 'v-tooltip';
import VueBarcode from 'vue-barcode';
import { mapActions, mapGetters } from 'vuex';
import Input from '@/components/ui/AppInput.vue';
// import Toggle from '@/components/ui/AppToggle.vue';
import AssetV3 from '@/components/common/AssetV3.vue';
// import CheckBox from '@/components/ui/AppCheckbox.vue';
import UIButton from '@/components/ui/AppButton.vue';
import Button from '@/components/common/Button.vue';
import UtilMixin from '@/mixins/util';
import { QuestionMarkCircleIcon } from '@vue-hero-icons/outline';
import StringMixin from '@/mixins/string';
import QRCode from '@/components/common/QRCode.vue';
import VisaIcon from '@/feature/onboarding/components/assets/visa.png';
import AmexIcon from '@/feature/onboarding/components/assets/amex.png';
import MasterCardIcon from '@/feature/onboarding/components/assets/mastercard.png';
import DinersIcon from '@/feature/onboarding/components/assets/diners.png';
import GenericIcon from '@/feature/onboarding/components/assets/generic.svg';
import OnboardingLoading from '@/feature/onboarding/views/OnboardingLoading.vue';

Vue.use(VTooltip);

export default {
  directives: { mask },
  mixins: [UtilMixin, StringMixin],
  props: {
    options: {
      type: Array,
      default: () => [],
    },
    downPaymentValue: {
      type: Number,
      default: 0,
    },
  },
  components: {
    Button,
    UIButton,
    AssetV3,
    QRCode,
    // CheckBox,
    OnboardingLoading,
    QuestionMarkCircleIcon,
    VueBarcode,
    Input,
    // Toggle,
  },
  data() {
    return {
      order: null,
      optionsData: this.formatOptionsData(this.options),
      tooltipDisabled: true,
      creditCard: {
        number: '',
        verification_value: '',
        expiration: '',
        first_name: '',
        last_name: '',
        full_name: '',
      },
      tooltipDisabledCVV: false,
      validate: {
        number: '',
        name: '',
        verification_value: '',
        expiration: '',
      },
      saveCardToken: false,
      creditCardDisabled: true,
      payLoading: false,
      cardLogo: GenericIcon,
    };
  },
  computed: {
    ...mapGetters('onboarding', ['getIuguUser', 'getTransactionID', 'getUserID']),
    currentOptions: {
      get() {
        return this.optionsData;
      },
      set(value) {
        this.optionsData = value;
      },
    },
    isOnlyCredit() {
      return this.$route.query?.payWithCredit;
    },
    currentSelected() {
      let selected = null;
      this.currentOptions.forEach((option) => {
        if (option.selected) {
          selected = option;
        }
      });
      return selected;
    },
    isSmall() {
      return this.isMobile();
    },
    payButtonText() {
      return `Pagar ${this.downPaymentValue.toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL',
      })}`;
    },
    creditCardFlag() {
      return this.$window.Iugu?.utils.getBrandByCreditCardNumber(this.creditCard.number);
    },
  },
  methods: {
    ...mapActions('onboarding', ['createIuguUser', 'payWithCreditCard']),
    mountOrder() {
      const orderObject = {};
      this.options.forEach((option) => {
        if (option.type === 'pix-method') {
          orderObject.pix = {
            ...option,
          };
        }
        if (option.type === 'billet-method') {
          orderObject.billet = {
            ...option,
          };
        }
        if (option.type === 'credit-card') {
          orderObject.credit = {
            ...option,
          };
        }
      });
      return orderObject;
    },
    formatOptionsData(data) {
      const newOptions = [];
      data.forEach((option) => {
        if (option.type === 'billet-method') {
          newOptions.push({
            type: option.type,
            label: option.label,
            selected: false,
          });
        } else {
          newOptions.push({
            type: option.type,
            label: option.label,
            selected: true,
          });
        }
      });
      return newOptions;
    },
    selectMethod(option) {
      const newOptions = [];
      this.currentOptions.forEach((op) => {
        if (op.type === option.type) {
          newOptions.push({ ...op, selected: true });
        } else {
          newOptions.push({ ...op, selected: false });
        }
      });
      this.currentOptions = newOptions;
      document.getElementById(option.type).childNodes[1].click();
    },
    copyBarcode(text) {
      navigator.clipboard.writeText(text);
    },
    copyPixCode(text) {
      navigator.clipboard.writeText(text);
      if (this.tooltipDisabled) {
        this.tooltipDisabled = false;
      } else {
        this.tooltipDisabled = true;
      }
    },
    showCVVTooltip() {
      if (this.tooltipDisabledCVV) {
        this.tooltipDisabledCVV = false;
      } else {
        this.tooltipDisabledCVV = true;
      }
    },
    removeMask(value) {
      return value.split('.').join().split(' ').join()
        .replaceAll(',', '');
    },
    openBillet() {
      window.open(this.order.billet.downPaymentLink);
    },
    getCreditCardLogo() {
      this.cardLogo = GenericIcon;
      if (this.creditCardFlag === 'visa') {
        this.cardLogo = VisaIcon;
      }

      if (this.creditCardFlag === 'mastercard') {
        this.cardLogo = MasterCardIcon;
      }

      if (this.creditCardFlag === 'amex') {
        this.cardLogo = AmexIcon;
      }

      if (this.creditCardFlag === 'diners') {
        this.cardLogo = DinersIcon;
      }
    },
    cleanErrors(type) {
      if (type === 'number' && this.creditCard?.number?.length !== 0) {
        this.getCreditCardLogo();
      }

      if (type === 'number' && this.validate.number.length > 0 && this.creditCard.number.length !== 0) {
        this.validate.number = '';
      }

      if (type === 'name' && this.validate.name.length > 0 && this.creditCard.full_name.length !== 0) {
        this.validate.name = '';
      }

      if (type === 'expiration' && this.validate.expiration.length > 0 && this.creditCard.expiration.length !== 0) {
        this.validate.expiration = '';
      }

      if (type === 'verification_value' && this.validate.verification_value.length > 0 && this.creditCard.verification_value.length !== 0) {
        this.validate.verification_value = '';
      }
    },
    validateCardValues() {
      if (this.creditCard.full_name.length === 0) {
        this.validate.name = 'Nome associado ao cartão é obrigatório';
      } else {
        this.validate.name = '';
        this.creditCard.full_name = this.creditCard.full_name.toUpperCase();
        this.creditCard.first_name = this.creditCard.full_name.split(' ').slice(0, -1).join(' ');
        this.creditCard.last_name = this.creditCard.full_name.split(' ').slice(-1).join(' ');
      }

      if (this.creditCard.first_name.length <= 0 && this.creditCard.last_name.length <= 0) {
        this.validate.name = 'Campo obrigatório';
      } else if (this.creditCard.first_name.length <= 0
        || this.creditCard.last_name.length <= 0) {
        this.validate.name = 'Insira nome e sobrenome';
      }

      if (!this.$window.Iugu.utils.validateCreditCardNumber(this.creditCard.number)) {
        this.validate.number = 'Número de cartão não reconhecido';
      } else {
        this.validate.number = '';
      }

      if (this.creditCard.number.length <= 0) {
        this.validate.number = 'Campo obrigatório';
      }

      if (this.creditCard.expiration.length > 0 && !this.$window.Iugu
        .utils.validateCVV(this.creditCard.verification_value, this.creditCardFlag)) {
        this.validate.verification_value = 'Código de verificação invalido';
      } else {
        this.validate.verification_value = '';
      }

      if (!this.$window.Iugu
        .utils.validateCVV(this.creditCard.verification_value, this.creditCardFlag)) {
        this.validate.verification_value = 'Código de verificação invalido';
      } else {
        this.validate.verification_value = '';
      }

      if (this.creditCard.verification_value.length <= 0) {
        this.validate.verification_value = 'Campo obrigatório';
      }

      if (!this.$window.Iugu.utils.validateExpirationString(this.creditCard.expiration)) {
        this.validate.expiration = 'Data de expiração invalida';
      } else {
        this.validate.expiration = '';
      }

      if (this.creditCard.expiration.length <= 0) {
        this.validate.expiration = 'Campo obrigatório';
      }
    },
    async createCreditCardPaymentToken() {
      this.validateCardValues();
      this.payLoading = true;
      const month = this.creditCard.expiration.replace(/\//g, '').slice(0, 2);
      const year = this.creditCard.expiration.replace(/\//g, '').slice(2, 6);
      const CreditCard = await this.$window.Iugu.CreditCard(
        this.creditCard.number.replace(/\D/g, ''),
        month.toString(),
        year.toString(),
        this.creditCard.first_name.toUpperCase(),
        this.creditCard.last_name.toUpperCase(),
        this.creditCard.verification_value.replace(/\D/g, ''),
      );
      this.$window.Iugu.createPaymentToken(CreditCard, async (response) => {
        if (response.errors) {
          this.$notify({
            text: response.errors.record_invalid,
            type: 'error',
            duration: 5000,
          });
          this.payLoading = false;
        } else {
          try {
            // if (this.saveCardToken) {
            //   await this.createIuguUser(
            //     {
            //       userId: this.getUserID,
            //       transactionId: this.getTransactionID,
            //       token: response.id,
            //     },
            //   ).then((res) => {
            //     if (res.name === 'Error') {
            //       throw Error('Erro ao criar token de usuário.');
            //     }
            //   });
            // }
            await this.payWithCreditCard({
              userId: this.getUserID,
              transactionId: this.getTransactionID,
              isPaymentMethodSaved: this.saveCardToken,
              token: response.id,
            }).then((paymentResponse) => {
              if (!paymentResponse.data.success) {
                this.payLoading = false;
                this.$notify({
                  text: paymentResponse.data.errors?.base
                    ? paymentResponse.data.errors.base[0]
                    : paymentResponse.data.message,
                  type: 'error',
                  duration: 5000,
                });
              } else if (paymentResponse.data.success) {
                const {
                  transactionId,
                  onboardingToken,
                  proposalId,
                  errorTag,
                } = this.$route.query;

                const queryObject = {
                  onboardingToken,
                  transactionId,
                  proposalId,
                  errorTag,
                };

                this.$router.replace({
                  name: 'onboarding-next-steps',
                  query: {
                    ...queryObject,
                    payWithCreditPaid: true,
                  },
                }).then(() => {
                  this.$router.go();
                });
              }
            });
          } catch (error) {
            this.payLoading = false;
            setTimeout(() => {
              this.$notify({
                text: error.response || error.message,
                type: 'error',
                duration: 5000,
              });
            }, 100);
          }
        }
      });
    },
  },
  created() {
    this.order = this.mountOrder();
  },
  mounted() {
    const isHomolog = window.location.host.includes('-homolog');
    document.getElementById('pix-method').childNodes[1].click();
    this.$loadScript('https://js.iugu.com/v2')
      .then(() => {
        this.$window.Iugu.setAccountID('ADF87B047F8F440D9083DD8167854F1A');
        if (isHomolog) {
          this.$window.Iugu.setTestMode(true);
        }
        this.$window.Iugu.setup();
      })
      .catch(() => {
        this.creditCardDisabled = true;
      });
    if (this.$route.query.payWithCredit) {
      this.selectMethod({
        type: 'credit-card',
        label: 'Cartão',
      });
    }
  },
};
</script>

<style lang="scss" scoped>

.tooltipButton {
  display: flex;
  align-items: center;
  border: none !important;
  outline: none !important;
  background: transparent;
  padding: 0;
  width: 24px;
  height: 24px;
  color: #94A3B8;
}

.exp-wrapper:after {
  content: "/";
  position: absolute;
  left: 50px;
  top: 4px;
  margin-left: -4px;
  color: #aaa;
}

.payment-method-wrapper {
  display: flex;
  gap: 12px;
}

.hidden-selector {
  display: none;
}

.options {
  display: flex;
  position: relative;
  width: 100%;
  justify-content: space-between;
  padding: 12px;
  border: 1px solid #c4cdd5;
  border-radius: 8px;
  align-items: center;
}

.options:hover {
  border: 1px solid #72beda;
  cursor: pointer;
}

.label-wrapper {
  display: flex;
  flex-direction: column;
  align-items: flex-start !important;
  gap: 8px !important;
  align-items: center;
  font-size: 14px;
  font-weight: 600;
  line-height: 24px;
}

.paymentIcon {
  color: black;
  max-width: 24px;
  max-height: 24px;
}

.selected {
  background: #ecf6fa;
  border: 1px solid #72beda;
}

.title-barcode {
  font-family: Usual;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  color: #64748B;
}

.ticket {
  margin-top: 20px;
  display: flex;
  gap: 20px;
  flex-direction: column;

  @media (min-width: $md) {
    align-items: center;
  }
}

.barcode-options {
  display: flex;
  gap: 20px;
  align-self: center;
  align-items: center;
}

.disclaimer {
  font-family: Usual;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  color: #64748B;

  @media (min-width: $md) {
    gap: 8px;
  }
}

.disclaimer-pix {
  display: flex;
  flex-direction: column;
  color: #64748B;
  font-family: Usual;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;

  @media (min-width: $md) {
    gap: 8px;
  }
}

.ticket-button {
  margin: 0 !important;
}

.credit {
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-top: 20px;
}

.credit>.credit-form {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
}

@media (min-width: $md) {
  .credit>.credit-form {
    align-items: flex-start;
  }
}

.credit>.credit-form .credit-form-input {
  width: 100%;
  max-width: 600px;
  margin-bottom: 0px;
  flex-direction: column;´

  &.name ::v-deep input {
    text-transform: uppercase
  }
}

.credit>.credit-form>.pay-button {
  width: 100%;
  height: 48px;
}

.credit>.credit-title {
  font-family: Usual;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
  font-weight: 700;
  line-height: 24px;
}

.card-flag {
  display: grid;
  grid-template-columns: 10% 50% 40%;
  padding: 12px 16px;
  align-items: center;
  position: relative;
}

.card-flag .name {
  font-size: 16px;
  line-height: 24px;
  color: #212b36;
}

.card-flag .expirationDate {
  font-size: 14px;
  line-height: 20px;
  color: #637381;
}

.radio-card {
  position: absolute;
  width: 20px;
  display: flex !important;
  height: 100%;
  margin: unset;
  right: 20px;
  align-items: center;
}

.button-copy {
  background: #ffffff;
  border: 1px solid #c4cdd5;
  border-radius: 4px;
  font-size: 16px;
  line-height: 24px;
  color: #212b36;
  display: flex;
  padding: 4px 8px;
  margin-top: 8px;
  align-items: center;
  cursor: pointer;
}

.button-copy:hover {
  background-color: var(--gray-100);
}

.button-copy img {
  margin-right: 8px;
}

.scan {
  font-size: 14px;
  line-height: 20px;
  color: #637381;
}

.qr-code {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.qr-code-box {
  border: 1px solid #dfe3e8;
  border-radius: 4px;
  margin-bottom: 8px;
  overflow: hidden;
}

.pix {
  display: flex;
  margin-top: 20px;
  flex-direction: column;
  gap: 20px;
}

.pix-content {
  display: flex;
  flex-direction: column;
  gap: 20px;

  @media (min-width: $md) {
    flex-direction: row;
    gap: 36px;
  }
}

.instructions {
  display: flex;
  flex-direction: column;
  gap: 12px;

  &.mobile {
    margin: 0px;
  }
}

.instruction-wrapper-title {
  color: #0F172A;
  font-family: Usual;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
}

.instruction-wrapper {
  display: flex;
  gap: 8px;
  font-family: Usual;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  color: #64748B;
  position: relative;
}

.instruction-wrapper-number {
  color: #64748B;
  text-align: center;
  border-radius: 50%;
  background: #E2E8F0;
  min-width: 24px;
  max-width: 24px;
  min-height: 24px;
  max-height: 24px;
}

.grey-hover:hover {
  background-color: var(--gray-100);
  border-radius: 4px;
}

.barcode-number {
  overflow-wrap: anywhere;
  color: #212b36;
}

.barcode {
  text-align: center;
  width: 80%;

  &.mobile {
    width: 100%;
  }
}

.barcode-svg {
  width: 100%;
  height: auto;
  margin-bottom: 12px;
  object-fit: contain;
}

.payment-selector-radio-input {
  position: absolute;
  top: 6px;
  right: 6px;
  margin: 0;
  width: 8px !important;
  height: 8px !important;
  accent-color: #36A3CA !important;
  border-radius: 50% !important;
  padding: 7px;
  background-clip: content-box;
  background: transparent !important;
  appearance: none;
}

.payment-selector-radio-input:checked {
  background-color: #36A3CA;
  padding: 4px;
  border: 4px solid #36A3CA;
}

@media (max-width: $sm) {
  .title-barcode {
    font-size: 16px;
    line-height: 24px;
    color: #637381;
  }

  .barcode {
    font-size: 16px;
    line-height: 24px;
    color: #212b36;
    text-align: left;
  }

  .barcode-options {
    width: 100%;
    display: flex;
    align-self: center;
    position: relative;
    align-items: center;
    flex-direction: column;
  }

  .qr-code {
    display: none;
  }
}

.tooltip {
  display: block !important;
  z-index: 2;

  .tooltip-text {
    background: var(--gray-600);
    color: white;
    border-radius: 4px;
    padding: 4px 8px 4px 8px;
    text-align: center;
  }

  .tooltip-text-cvv {
    color: white;
    font-family: Usual;
    background: #0F172A;
    border-radius: 6px;
    padding: 12px;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    position: absolute;
    top: -84px;
    left: -329px;
    width: 327px;
    line-height: 20px;

    @media (max-width: 406px) {
      position: absolute;
      top: -84px;
      left: -302px;
      width: 300px;
    }

    @media (max-width: 350px) {
      position: absolute;
      top: -104px;
      left: -252px;
      width: 250px;
    }
  }

  .tooltip-arrow {
    width: 0;
    height: 0;
    border-style: solid;
    position: absolute;
    margin: 1px;
    border-color: var(--gray-600);
    z-index: 1;
  }

  .tooltip-arrow-cvv {
    width: 0;
    height: 0;
    border-style: solid;
    position: absolute;
    margin: 1px;
    border-color: #0F172A;
    z-index: 1;
  }

  &[x-placement^="top"] {
    margin-bottom: 5px;

    .tooltip-arrow {
      border-width: 5px 5px 0 5px;
      border-left-color: transparent !important;
      border-right-color: transparent !important;
      border-bottom-color: transparent !important;
      bottom: -5px;
      left: calc(50% - 5px);
      margin-top: 0;
      margin-bottom: 0;
    }

    .tooltip-arrow-cvv {
      border-width: 5px 5px 0 5px;
      border-left-color: transparent !important;
      border-right-color: transparent !important;
      border-bottom-color: transparent !important;
      bottom: -5px;
      left: calc(9% - 5px);
      margin-top: 0;
      margin-bottom: 0;
    }
  }

  &[x-placement^="bottom"] {
    margin-top: 5px;

    .tooltip-arrow {
      border-width: 0 5px 5px 5px;
      border-left-color: transparent !important;
      border-right-color: transparent !important;
      border-top-color: transparent !important;
      top: -5px;
      left: calc(50% - 5px);
      margin-top: 0;
      margin-bottom: 0;
    }
  }

  &[x-placement^="right"] {
    margin-left: 5px;

    .tooltip-arrow {
      border-width: 5px 5px 5px 0;
      border-left-color: transparent !important;
      border-top-color: transparent !important;
      border-bottom-color: transparent !important;
      left: -5px;
      top: calc(50% - 5px);
      margin-left: 0;
      margin-right: 0;
    }
  }

  &[x-placement^="left"] {
    margin-right: 5px;

    .tooltip-arrow {
      border-width: 5px 0 5px 5px;
      border-top-color: transparent !important;
      border-right-color: transparent !important;
      border-bottom-color: transparent !important;
      right: -5px;
      top: calc(50% - 5px);
      margin-left: 0;
      margin-right: 0;
    }
  }

  &[aria-hidden="true"] {
    visibility: hidden;
    opacity: 0;
    transition: opacity 0.15s, visibility 0.15s;
  }

  &[aria-hidden="false"] {
    visibility: visible;
    opacity: 1;
    transition: opacity 0.15s;
  }
}
</style>

<style lang="scss">
.barcode-options .button-wrapper:nth-child(1) div {
  background: transparent !important;
  border: 1px solid #c4cdd5 !important;
  color: #212b36 !important;
}

.barcode-options .button-wrapper:nth-child(2) div {
  background: transparent !important;
  border: 1px solid #c4cdd5 !important;
  color: #212b36 !important;
}

@media (max-width: $sm) {

  .barcode-options .button-wrapper,
  .copy-buttom-sm .button-wrapper {
    width: inherit;
    position: relative;
    border-radius: 4px;
  }

  .barcode-options .button-wrapper div,
  .copy-buttom-sm .button-wrapper div {
    font-weight: normal;
    width: 100%;
    padding-top: 12px;
    padding-bottom: 12px;
    padding-right: unset;
    justify-content: center;
    padding-left: unset;
    color: var(--Neutral-White, #FFF);
    text-align: center;
    font-family: Usual;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 24px;
  }

  .barcode-options .button-wrapper div span,
  .copy-buttom-sm .button-wrapper div span {
    height: 14px;
    display: flex;
    align-items: center;
    margin-right: 5px;
    position: absolute;
    left: 12px;
  }

  .barcode-options .button-wrapper:nth-child(1) div {
    background: #36A3CA !important;
    border: 1px solid #c4cdd5 !important;
    color: white !important;
  }

  .copy-buttom-sm div {
    color: #ffffff !important;
  }

  .barcode-options .button-wrapper:nth-child(2) div {
    background: transparent !important;
    border: 1px solid #c4cdd5 !important;
    color: #212b36 !important;
  }

  .barcode-options .v-popover .trigger {
    display: block !important;
  }

  .copy-buttom-sm .v-popover .trigger {
    display: block !important;
  }

  .barcode-options .ticket-button {
    display: block !important;
  }
}
</style>
